import {SpreadsheetValidationErrorInfo} from 'bulk-import/SpreadsheetBulkImportConstants';
import {FromServerId, ServerEntryVersion} from 'notebook/ELNConstants';
import * as TaskRunner from 'util/TaskRunner';
import {StageEntryDetails, StageRunSample} from 'workflows/WorkflowConstants';

export interface SpreadsheetParams {
  filename: string;
  location: string;
  columnTypes: Array<string>;
  _timeLimit: number | null;
}

export function validateNewSamplesForInputTableImport(
  spreadsheetParams: SpreadsheetParams,
  stageEntryId: string
): JQueryPromise<SpreadsheetValidationErrorInfo> {
  return TaskRunner.postJSON({
    url: `/1/api/workflows/input-tables:validate-new-samples-for-import`,
    data: {
      ...spreadsheetParams,
      stageEntryId,
    },
  });
}

export interface AddNewSamplesForInputTableImportResponse {
  stageEntryDetails: StageEntryDetails;
  entryVersion: ServerEntryVersion<FromServerId>;
  stageRunSamples: Array<StageRunSample>;
}

export function addNewSamplesForInputTableImport(
  spreadsheetParams: SpreadsheetParams,
  stageEntryId: string
): JQueryPromise<AddNewSamplesForInputTableImportResponse> {
  return TaskRunner.postJSON({
    url: '/1/api/workflows/input-tables:add-new-samples-for-import',
    data: {
      ...spreadsheetParams,
      stageEntryId,
    },
  });
}
